import React from 'react';

import { APTypography } from '@astropay/web-core-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonBase, Grow, useTheme } from '@material-ui/core';
import classnames from 'classnames';

import { CardInfo } from 'deposit/services/deposit-service';

import { translate } from 'common/config/i18n';

import { useVoucherStyles } from './styles';

interface VoucherProps {
  selected: boolean;
  voucher?: CardInfo;
  // eslint-disable-next-line
  onSelect?: (card: CardInfo, element: any) => void;
  disabled?: boolean;
}

const Voucher: React.FC<VoucherProps> = ({ voucher, onSelect, selected, disabled }) => {
  const classes = useVoucherStyles();
  const theme = useTheme();

  const handleData = (event: React.MouseEvent | React.FocusEvent) => {
    voucher && onSelect && onSelect(voucher, event.target);
  };

  return (
    <ButtonBase
      component={'div'}
      className={classnames(classes.root, { disabled: disabled, nonClickable: !onSelect })}
      disabled={disabled}
      onClick={voucher && handleData}
      onFocus={voucher && handleData}
      id={voucher && `${voucher.idCard}`}
    >
      <Grow in={selected} mountOnEnter unmountOnExit>
        <div>
          <FontAwesomeIcon
            size="lg"
            icon={['fad', 'check-circle']}
            className={classnames(classes.selectedIcon, { show: selected })}
          />
        </div>
      </Grow>
      <figure className="astropaylogo"></figure>

      {voucher && (
        <div className={classes.voucherInfo}>
          <APTypography
            textStyle="Typography_Poppins_12px_SemiBold"
            variant="inherit"
            className="expirationDate"
            customColor={theme.colors.global.Neutral_100}
          >
            {translate('deposit_voucher_expiration_abbreviation')}{' '}
            <span className="value">
              {voucher.expirationMonth}/{voucher.expirationYear.slice(-2)}
            </span>
          </APTypography>
          <APTypography
            textStyle="Typography_Poppins_12px_SemiBold"
            variant="inherit"
            className="availableCredit"
            customColor={theme.colors.global.Neutral_100}
          >
            {voucher.currency} <span className="value">{voucher.availableCredit}</span>
          </APTypography>
        </div>
      )}
    </ButtonBase>
  );
};

export default Voucher;
